import React from 'react';
import { Flame } from 'lucide-react';
import { C, SourcedRow, PanelShell, Loading, Degraded, useFetch, fmtValue, confidenceStyle } from './shared';

const TILES = ['flood_band', 'bushfire_prone', 'coastal_inundation', 'wind_region'];
const ROWS = ['arpc_wind_band', 'arpc_flood_surge_group', 'cyclone_pool_eligible', 'storm_hail_zone', 'earthquake_zone', 'crime_index', 'bal_rating'];

const Tile = ({ name, s }) => (
  <div className="rounded-sm border border-[rgba(136,150,168,0.2)] p-2" data-testid={`property-hazard-${name}`}>
    <p className="text-[9px] uppercase tracking-wider" style={{ color: C.slate }}>{name.replace(/_/g, ' ')}</p>
    <p className="text-sm font-semibold mt-0.5" style={{ color: C.navy }} data-testid={`property-hazard-${name}-value`}>{fmtValue(s?.value)}</p>
    <span className="text-[9px] font-semibold px-1 py-0.5 rounded uppercase" style={confidenceStyle(s?.confidence)} data-testid={`property-hazard-${name}-confidence`}>{(s?.confidence || '').replace('_', ' ')}</span>
    <p className="text-[9px] mt-1 leading-tight line-clamp-3" style={{ color: C.slate }} title={s?.source}>{s?.determination || s?.source}</p>
  </div>
);

export const PropertyHazardsPanel = ({ api, pid }) => {
  const [hz, err] = useFetch(api, pid ? `/property/${encodeURIComponent(pid)}/hazards` : null, [pid]);
  if (err) return <PanelShell title="Hazards" icon={<Flame className="w-3 h-3" />} testid="property-hazards-panel"><p className="text-[11px] py-3" style={{ color: C.red }}>{String(err)}</p></PanelShell>;
  if (!hz) return <PanelShell title="Hazards" icon={<Flame className="w-3 h-3" />} testid="property-hazards-panel"><Loading what="the flood, bushfire and storm tide layers" /></PanelShell>;
  const asked = hz.layers_asked || [];
  return (
    <PanelShell title="Hazards" icon={<Flame className="w-3 h-3" />} testid="property-hazards-panel"
      meta={<span data-testid="property-hazards-meta">{asked.length} layers asked · {asked.filter(l => l.match).length} hits · {hz.elapsed_ms} ms</span>}>
      <div className="grid grid-cols-2 gap-2 mt-2">
        {TILES.map(k => <Tile key={k} name={k} s={hz[k]} />)}
      </div>
      <div className="mt-2">
        {ROWS.map(k => <SourcedRow key={k} name={k} s={hz[k]} testid={`property-hazard-${k}`} />)}
      </div>
      {hz.attribution?.length > 0 && (
        <div className="mt-2 space-y-0.5" data-testid="property-hazards-attribution">
          {hz.attribution.map((a, i) => <p key={i} className="text-[9px]" style={{ color: C.slate }}>{a}</p>)}
        </div>
      )}
      <Degraded items={hz.degraded} testid="property-hazards-degraded" />
    </PanelShell>
  );
};
